var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityBubbleImage } from './entity-bubble-image';
import { CellLabel } from '../elements/cell-label';
import { useLink } from '../hooks/use-link';
import { useLang } from '../hooks/use-lang';
import { DownloadFlatLineIconGlyph } from '@shapeable/icons';
var cls = classNames('file-asset-embed');
export var FileAssetEmbedDefaultProps = {
  linkStyles: {
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'flex !important',
    flexGrow: 1
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    border-radius: ", ";\n    margin: ", " 0;\n    border-radius: ", ";\n    box-shadow: 4px 4px 16px 0px ", ";\n\n    ", "\n  "], ["\n    display: flex;\n    gap: ", ";\n    border-radius: ", ";\n    margin: ", " 0;\n    border-radius: ", ";\n    box-shadow: 4px 4px 16px 0px ", ";\n\n    ", "\n  "])), theme.UNIT(3), theme.UNIT(3), theme.UNIT(4), theme.UNIT(2), theme.COLOR('app-chrome'), function (_a) {
    var hasUrl = _a.hasUrl;
    return hasUrl && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        box-shadow: 8px 8px 20px 0px ", ";\n        ", ";\n      }\n    "], ["\n      &:hover {\n        box-shadow: 8px 8px 20px 0px ", ";\n        ", ";\n      }\n    "])), theme.COLOR('app-chrome'), theme.TRANSITION('box-shadow'));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding: ", " ", " ", " 0;\n    justify-content: space-between;\n    gap: ", ";\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding: ", " ", " ", " 0;\n    justify-content: space-between;\n    gap: ", ";\n    width: 100%;\n  "])), theme.UNIT(1), theme.UNIT(2), theme.UNIT(1), theme.UNIT(1))
});
var ImageStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n    padding: ", ";\n    background: ", ";\n    border-radius: ", " 0 0 ", ";\n  "], ["\n    flex-shrink: 0;\n    padding: ", ";\n    background: ", ";\n    border-radius: ", " 0 0 ", ";\n  "])), theme.UNIT(5), theme.COLOR('app-chrome'), theme.UNIT(2), theme.UNIT(2))
});
var TypeAndSizeStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(1))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('strong'))
});
var FileMetaStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  "])))
});
var EntityTypeStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", " !important;\n    font-size: 0.7em !important;\n    margin: 0 !important;\n  "], ["\n    color: ", " !important;\n    font-size: 0.7em !important;\n    margin: 0 !important;\n  "])), theme.COLOR('sub'))
});
var NameStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    line-height: 1.3;\n    ", ";\n  "], ["\n    line-height: 1.3;\n    ", ";\n  "])), theme.MAX_LINES(2))
});
var FileSizeStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: 2px;\n\n    &:before {\n      content: '\u2022';\n      font-size: 1.3em;\n      margin-right: ", ";\n    }\n  "], ["\n    ", ";\n    padding-bottom: 2px;\n\n    &:before {\n      content: '\u2022';\n      font-size: 1.3em;\n      margin-right: ", ";\n    }\n  "])), EntityTypeStyles, theme.UNIT(1))
});
var FileTypeStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font-size: ", "em;\n    color: ", ";\n  "], ["\n    font-size: ", "em;\n    color: ", ";\n  "])), 12 / 14, theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  NAME: 'FileAssetEmbed',
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Image: styled(EntityBubbleImage)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Header: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  FileMeta: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), FileMetaStyles),
  TypeAndSize: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), TypeAndSizeStyles),
  EntityType: styled(CellLabel)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), EntityTypeStyles),
  FileType: styled.span(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), FileTypeStyles),
  Name: styled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  FileSize: styled.span(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), FileSizeStyles)
};
export var FileAssetEmbed = function (props) {
  var _a = useComponentProps(My.NAME, FileAssetEmbedDefaultProps, props),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    linkStyles = _a.linkStyles;
  var Link = useLink().Link;
  var t = useLang();
  var file = entity.file,
    name = entity.name;
  var formattedSize = file.formattedSize,
    url = file.url,
    typeName = file.typeName;
  if (!entity) {
    return null;
  }
  ;
  var inner = React.createElement(My.Container, {
    hasUrl: !!url,
    className: cls.name(className)
  }, React.createElement(My.Image, {
    entity: entity,
    size: 60
  }), React.createElement(My.Body, null, React.createElement(My.Header, null, React.createElement(My.FileMeta, null, React.createElement(My.TypeAndSize, null, !!entity.__typename && React.createElement(My.EntityType, {
    tag: 'h6'
  }, entityTypeNameFor(entity)), !!formattedSize && React.createElement(My.FileSize, null, t(formattedSize))), React.createElement(DownloadFlatLineIconGlyph, {
    size: 16,
    colors: {
      fill: 'text'
    }
  })), !!name && React.createElement(My.Name, null, name)), !!typeName && React.createElement(My.FileType, null, t(typeName)), children));
  return React.createElement(React.Fragment, null, !!url ? React.createElement(Link, {
    style: linkStyles,
    href: url
  }, inner) : inner);
};
FileAssetEmbed.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;